// Helper ngày cho form nhập liệu. Tách khỏi format.ts vì đây là "sinh giá trị
// mặc định / parse input", còn format.ts là "hiển thị".

/**
 * Hôm nay theo giờ LOCAL. Không dùng toISOString() trực tiếp: nó trả UTC nên
 * buổi tối ở VN sẽ ra ngày hôm trước.
 */
export function todayISO(): string {
  const d = new Date();
  const mm = String(d.getMonth() + 1).padStart(2, "0");
  const dd = String(d.getDate()).padStart(2, "0");
  return `${d.getFullYear()}-${mm}-${dd}`;
}

/** n tháng gần nhất, mới nhất trước: ["2026-09", "2026-08", …] */
export function lastMonths(n = 6): string[] {
  const out: string[] = [];
  const d = new Date();
  for (let i = 0; i < n; i++) {
    out.push(new Date(Date.UTC(d.getFullYear(), d.getMonth() - i, 15)).toISOString().slice(0, 7));
  }
  return out;
}

/**
 * Ngày người ta gõ tay trong ticket Teams → ISO. "6/5", "06-05-2026", "6/5/26".
 * Thứ tự là NGÀY/THÁNG (kiểu VN). Không nhận diện được → "".
 */
export function normalizeDate(s: string): string {
  const m = String(s).match(/(\d{1,2})[/\-.](\d{1,2})(?:[/\-.](\d{2,4}))?/);
  if (!m) return "";
  // Group 1 và 2 luôn khớp (regex không cho optional); group 3 (năm) mới optional.
  const d = m[1]!;
  const mo = m[2]!;
  const rawY = m[3];
  const y = rawY ? (rawY.length === 2 ? `20${rawY}` : rawY) : String(new Date().getFullYear());
  const dt = new Date(Date.UTC(Number(y), Number(mo) - 1, Number(d)));
  return Number.isNaN(dt.getTime()) ? "" : dt.toISOString().slice(0, 10);
}
